import React, { memo } from 'react';
import { PanelView } from '@rendering/lookup';
import { Preview } from '@rendering/product-preview-react';
import { Carousel, CarouselSlide, FluidImage } from '@vp/swan';
import { BookletPreviewPage } from 'src/utils/BookletPreviews/types';
import { text } from 'src/utils/localizationUtil';
import { getPreviewUser } from 'src/utils/previewUtil';

type PreviewCarouselProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  previewsCarouselRef: React.RefObject<any>;
  bookletPreviews: BookletPreviewPage[];
  cimDocUrl: string;
  isBookletPreviewAvailable: boolean;
  panelViews: PanelView[];
  afterSlideChangeCb: (index: number) => void;
};

export const PreviewCarousel = memo(function PreviewCarousel({
  previewsCarouselRef,
  bookletPreviews,
  cimDocUrl,
  isBookletPreviewAvailable,
  panelViews,
  afterSlideChangeCb,
}: PreviewCarouselProps) {
  const user = getPreviewUser();

  return (
    <Carousel
      accessibleTextForNext={text('preview-carousel-next')}
      accessibleTextForPrevious={text('preview-carousel-previous')}
      infinite={false}
      slidesToShow={1}
      slidesToScroll={1}
      ref={previewsCarouselRef}
      afterChange={afterSlideChangeCb}
    >
      {isBookletPreviewAvailable
        ? bookletPreviews.map(({ previewUrl }, index) => (
            <CarouselSlide className="preview-slide" key={index} px={7}>
              <FluidImage style={{ objectFit: 'contain' }} src={previewUrl} />
            </CarouselSlide>
          ))
        : panelViews.map((view, index) => (
            <CarouselSlide className="preview-slide" key={index} px={7}>
              <Preview key={index} cimDocUrl={cimDocUrl} user={user} view={view} />
            </CarouselSlide>
          ))}
    </Carousel>
  );
});
